module.exports = __webpack_public_path__ + "img/dat.315535b.svg";